export default __webpack_public_path__ + "static/media/yardi-logo-popup.017a67f3.svg";